import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerModel } from '../models/customer.model';
import { ProducerModel } from '../models/producer.model';
import { OrderService } from './order.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private orderService: OrderService
  ) { }

  /*
    salva um cliente em cache
  */
  saveCustomer(customer: any): void {
    this.orderService.setCustomer(customer);
    if (customer.rememberMe == true) {
      localStorage.setItem("customerLogged", JSON.stringify(customer));
    } else {
      sessionStorage.setItem("customerLogged", JSON.stringify(customer));
    }
  }

  /*
    salva um produtor em cache
  */
  saveProducer(producer: ProducerModel): void {
    if (producer.rememberMe == true) {
      localStorage.setItem("producerLogged", JSON.stringify(producer));
    } else {
      sessionStorage.setItem("producerLogged", JSON.stringify(producer));
    }
  }

  defineModeComissioner(comissioner: boolean): void {
    let customer: CustomerModel = this.getCustomer();
    customer.modeComissioner = comissioner;
    this.orderService.setCustomer(customer);
    localStorage.setItem("customerLogged", JSON.stringify(customer))
    this.router.navigateByUrl('/');
  }

  isComissionerMode(): boolean {
    let customer: CustomerModel = this.getCustomer();
    return customer?.modeComissioner ?? false;
  }

  /*
    pega o cliente em cache
  */
  getCustomer(): CustomerModel {
    if (localStorage.getItem('customerLogged') != null) {
      return JSON.parse(localStorage.getItem('customerLogged') ?? 'null')
    } else {
      return JSON.parse(sessionStorage.getItem('customerLogged') ?? 'null');
    }
  }

  /*
    pega o produtor em cache
  */
  getProducer(): ProducerModel {
    if (localStorage.getItem('producerLogged') != null) {
      return JSON.parse(localStorage.getItem('producerLogged') ?? 'null')
    } else {
      return JSON.parse(sessionStorage.getItem('producerLogged') ?? 'null');
    }
  }

  /*
    verifica se o cliente está logado
  */
  isLoggednIn(): boolean {
    if (this.getCustomer() !== null) {
      return true;
    } else {
      return false;
    }
  }

  /*
    verifica se o produtor está logado
  */
  isProducerLoggednIn(): boolean {
    if (this.getProducer() != null) {
      return true;
    } else {
      return false;
    }
  }

  /*
    desloga o cliente
  */
  onlyLogout(): void {
    localStorage.removeItem("rememberCustomer");
    sessionStorage.removeItem("customerLogged");
    localStorage.removeItem("customerLogged");
  }

  /*
    desloga o produtor e redireciona
  */
  producerLogout() {
    this.router.navigateByUrl('/');
    sessionStorage.removeItem("producerLogged");
    localStorage.removeItem("producerLogged");
  }

  /*
    desloga o produtor
  */
  producerOnlyLogout() {
    sessionStorage.removeItem("producerLogged");
    localStorage.removeItem("producerLogged");
  }

  /*
    desloga o cliente e redireciona
  */
  logout(): void {
    localStorage.removeItem("rememberCustomer");
    localStorage.removeItem("customerLogged");
    sessionStorage.removeItem("customerLogged");
    sessionStorage.removeItem("currentOrder");
    this.router.navigate(["/"]);
  }

  goTo(url: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
  }

  /*
    verifica se o cliente tem o perfil completado
  */
  hasCompleteProfile(): boolean {
    const customer = this.getCustomer();
    if (!customer.addressState ||
      !customer.addressCityId ||
      !customer.addressDistrict ||
      !customer.addressStreet
    ) {
      return false;
    }
    return true;
  }
}
